export const download = async (objectURL) => {
    const token = localStorage.getItem('SESSION');
    try {
        objectURL += `&Token=${token}`;
        const response = await fetch(objectURL, {
            method: 'POST',
            headers: {
                mode: 'no-cors', // no-cors, *cors, same-origin
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ download: false })
        });
        if (response.status === 200) {
            return externalDownload(objectURL);
        }
        return false;
    } catch (error) {
        return false;
    }
}

export const externalDownload = objectURL => {
    try {
        var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
        window.open(objectURL, !isSafari ? "_self" : "_blank");
        return true;
    } catch (error) {
        return false;
    }
}

export const downloadFileFromBlob = (blob, fileName) => {
    try {
        if (typeof blob === 'string') {
            blob = new Blob([Uint8Array.from(blob)], { type: 'application/octet-stream' });
        }
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return true;
    } catch (error) {
        console.log(error);
        return false;
    }
}